import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PCI'

const GetAlerts = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/alertas`, data, config)
const GetPCIWorks = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/getPci`, data, config)
const GetPCIWork = (obraID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/obra/${obraID}`, data, config)
const GetPCIItems = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/ItensModelo/${companyId}`, data, config)
const GetPCIItemsByPciID = (companyId, pciID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/ItensModelo/${companyId}?PCIID=${pciID}`, data, config)
const GetPCIs = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${companyId}`, data, config)
const MountPCI = (clone, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}?clone=${clone}`, data, config)
const GetLogReport = (reportId, startDate, endDate, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorioLog/${reportId}?startDate=${startDate}&endDate=${endDate}`, data, config)
const SendFolderObra = (obraId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/FolderObra/${obraId}`, data, config)
const GetResumeReport = (reportId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorioResumo/${reportId}`, data, config)
const GetResumeExport = (reportId, type, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/relatorioResumo/${reportId}/export/${type}`, data, config)
const GetLogs = (contractId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/log/${contractId}?limit=10&index=1`, data, config)
const ExportTeamExcel = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/equipe`, data, config, { responseType: 'blob' })
const GetPCIHeader = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/getPci/cabecalho`, data, config)
// Entrada do ZSistemas via SSO: referencias de contrato e obra -> { pciIds, obraId, referenciaObra }
const ResolverSSO = (empresaID, contrato, obra) => APIClient.get(`${APIPci}/${resourceName}/resolver`, { params: { empresaID, contrato, obra } })

const PCIRepository = {
  GetPCIItems,
  GetPCIItemsByPciID,
  GetPCIs,
  GetPCIWorks,
  GetPCIWork,
  GetAlerts,
  MountPCI,
  GetLogReport,
  GetResumeReport,
  GetResumeExport,
  SendFolderObra,
  GetLogs,
  ExportTeamExcel,
  GetPCIHeader,
  ResolverSSO
}

export default PCIRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pci.js